import React, {useEffect, useMemo} from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
// import {STRIPE_PUBLISHABLE_KEY_LIVE} from "../../../shared/constants";
import CheckoutForm from "./CheckoutForm";

// Make sure to call loadStripe outside of a component’s render to avoid recreating the Stripe object on every render.
// const promise = loadStripe(process.env.REACT_APP_PUBLISHABLE_STRIPE_KEY_EX_TEST);


// Initialize Stripe Elements
export default function StripeIndex(props) {

    const { order, onConfirm } = props;

    const stripeKey = useMemo(() => {
        const exEnv = [990, 1]
        if (order && exEnv.includes(order[0]['amount']['value'])) {
            console.log("EXU");
            return process.env.REACT_APP_PUBLISHABLE_STRIPE_KEY_EX_LIVE;
        } else {
            console.log("EXC");
            return process.env.REACT_APP_PUBLISHABLE_STRIPE_KEY;
        }
    }, [order]);

    const promise = useMemo(() => loadStripe(stripeKey), [stripeKey]);
    return (
        <div className="App">
            <Elements stripe={promise}>
                <CheckoutForm
                    order={order}
                    onConfirm={onConfirm}
                />
            </Elements>
        </div>
    );
}